import React from 'react';
import { RotateCcw, Trophy } from 'lucide-react';
interface GameOverProps {
  victory: boolean;
  score: number;
  maxCombo: number;
  onRestart: () => void;
}
export function GameOver({
  victory,
  score,
  maxCombo,
  onRestart
}: GameOverProps) {
  return <div className="absolute inset-0 flex items-center justify-center bg-black/80 backdrop-blur-sm" data-id="element-6">
      <div className="text-center space-y-6 px-8" data-id="element-7">
        {victory ? <>
            <Trophy className="w-24 h-24 text-yellow-400 mx-auto animate-bounce" data-id="element-8" />
            <h2 className="text-6xl font-bold text-yellow-400 drop-shadow-lg" data-id="element-9">
              VICTORY!
            </h2>
          </> : <>
            <div className="text-6xl" data-id="element-10">💀</div>
            <h2 className="text-6xl font-bold text-red-500 drop-shadow-lg" data-id="element-11">
              GAME OVER
            </h2>
          </>}

        <div className="space-y-3 text-white" data-id="element-12">
          <div className="text-3xl font-bold" data-id="element-13">
            Score:{' '}
            <span className="text-yellow-300" data-id="element-14">{score.toLocaleString()}</span>
          </div>
          <div className="text-xl" data-id="element-15">
            Max Combo: <span className="text-purple-400" data-id="element-16">{maxCombo}x</span>
          </div>
        </div>

        <button onClick={onRestart} className="px-8 py-4 bg-gradient-to-r from-purple-600 to-purple-500 hover:from-purple-500 hover:to-purple-400 text-white font-bold text-xl rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-3 mx-auto" data-id="element-17">
          <RotateCcw className="w-6 h-6" data-id="element-18" />
          PLAY AGAIN
        </button>
      </div>
    </div>;
}